var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DatePicker',{staticStyle:{"width":"100%"},attrs:{"format":_vm.fmt,"type":_vm.type,"placeholder":_vm.placeholder},on:{"on-change":_vm.getValue},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }